export const navlist = [
    {
        pages: "Home",
        next: "/"
    },
    {
        pages: "About",
        next: "/about"
    },
    {
        pages: "Skills",
        next: "/skills"
    },
    {
        pages: "Projects",
        next: "/projects"
    }
]